/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Workspace_LabelInputs */

const en_invite_workspace_label = /** @type {(inputs: Invite_Workspace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace`)
};

/** @type {(inputs: Invite_Workspace_LabelInputs) => LocalizedString} */
const ar_invite_workspace_label = en_invite_workspace_label;

/** @type {(inputs: Invite_Workspace_LabelInputs) => LocalizedString} */
const he_invite_workspace_label = en_invite_workspace_label;

/** @type {(inputs: Invite_Workspace_LabelInputs) => LocalizedString} */
const ur_invite_workspace_label = en_invite_workspace_label;

/** @type {(inputs: Invite_Workspace_LabelInputs) => LocalizedString} */
const es_invite_workspace_label = en_invite_workspace_label;

/** @type {(inputs: Invite_Workspace_LabelInputs) => LocalizedString} */
const fr_invite_workspace_label = en_invite_workspace_label;

/** @type {(inputs: Invite_Workspace_LabelInputs) => LocalizedString} */
const de_invite_workspace_label = en_invite_workspace_label;

/** @type {(inputs: Invite_Workspace_LabelInputs) => LocalizedString} */
const pt_invite_workspace_label = en_invite_workspace_label;

/** @type {(inputs: Invite_Workspace_LabelInputs) => LocalizedString} */
const hi_invite_workspace_label = en_invite_workspace_label;

/** @type {(inputs: Invite_Workspace_LabelInputs) => LocalizedString} */
const bn_invite_workspace_label = en_invite_workspace_label;

/**
* | output |
* | --- |
* | "Workspace" |
*
* @param {Invite_Workspace_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_workspace_label = /** @type {((inputs?: Invite_Workspace_LabelInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Workspace_LabelInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_workspace_label(inputs)
	if (locale === "he") return he_invite_workspace_label(inputs)
	if (locale === "ur") return ur_invite_workspace_label(inputs)
	if (locale === "es") return es_invite_workspace_label(inputs)
	if (locale === "fr") return fr_invite_workspace_label(inputs)
	if (locale === "de") return de_invite_workspace_label(inputs)
	if (locale === "pt") return pt_invite_workspace_label(inputs)
	if (locale === "hi") return hi_invite_workspace_label(inputs)
	if (locale === "bn") return bn_invite_workspace_label(inputs)
	return /** @type {LocalizedString} */ ("Workspace")
});